import { SVGProps } from '@commenda/icons/types';

const DefaultCustomerIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#F8F6F1"
      d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
    ></path>
    <path
      fill="#625DF5"
      d="M23 15.267h-4.265l3.694-2.132-.733-1.27-3.694 2.133 2.132-3.694-1.269-.732-2.132 3.692V9h-1.466v4.265l-2.132-3.693-1.27.732 2.132 3.693-3.693-2.132-.733 1.27 3.694 2.132H9v1.466h4.264l-3.693 2.133.733 1.27 3.694-2.133-2.133 3.693 1.27.733 2.132-3.693V23h1.466v-4.356l2.171 3.762 1.19-.687-2.172-3.763 3.773 2.179.733-1.27-3.693-2.132H23zm-7 2.726a1.99 1.99 0 0 1-1.841-2.756A1.993 1.993 0 1 1 16 17.993"
    ></path>
  </svg>
);

export { DefaultCustomerIcon };
